import React from 'react'
import { Radium } from '../hocs/Radium'

const mobileOnly = {
  '@media (min-width: 768px)': {
    display: 'none',
  },
}

const desktopOnly = {
  '@media (max-width: 767px)': {
    display: 'none',
  },
}

const filterStyles = (styleObject) => {
  if (typeof styleObject === 'undefined') {
    return undefined
  }

  return Object.keys(styleObject).reduce((acc, key) => {
    if (key === ':disabled') {
      return { ...acc, ...styleObject[key] }
    }

    if (key.includes(':')) {
      return acc
    }

    acc[key] = styleObject[key]

    return acc
  }, {})
}

export const TouchableOpacity = Radium(
  ({
    children,
    desktop = false,
    desktopStyle = undefined,
    disabled,
    forwardRef,
    mobile = false,
    onPress = () => {},
    style,
    ...props
  }) => {
    const disabledStyle = (() => {
      if (Array.isArray(style)) {
        return style.map((st) => filterStyles(st))
      }

      return filterStyles(style)
    })()

    return (
      <div
        ref={forwardRef}
        onClick={
          disabled
            ? () => {}
            : (e) => {
                e.stopPropagation()
                onPress()
              }
        }
        style={[
          {
            cursor: disabled ? 'default' : 'pointer',
            display: 'flex',
            flexDirection: 'column',
          },
          disabled ? disabledStyle : style,
          mobile && mobileOnly,
          desktop && desktopOnly,
          desktopStyle && {
            '@media (min-width: 768px)': {
              ...desktopStyle,
            },
          },
        ]}
        {...props}>
        {children}
      </div>
    )
  }
)
